import React, { useEffect, useState } from 'react';
import './index.css';
import { Route, Routes, BrowserRouter } from 'react-router-dom';

import Home from './Components/home/Home';
import About from './Components/about/About';
import Contact from './Components/contact/Contact';
import CommonBase from './Components/common-base/CommonBase';
import Nature from './Components/nature/Nature';
import Street from './Components/street/Street';
import Product from './Components/product/Product';
import Travel from './Components/travel/Travel';
import Wildlife from './Components/wildlife/Wildlife';
import Video from './Components/video/Video';

import { initializeApp } from 'firebase/app';
import { get, getDatabase, ref } from 'firebase/database';


function App(props) {

  const route = props.route

  const theme = "dark";

  const firebaseConfig = {
    apiKey: process.env.REACT_APP_api,
    authDomain: "priyanshdatyalclicks.firebaseapp.com",
    databaseURL: "https://priyanshdatyalclicks-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "priyanshdatyalclicks",
    storageBucket: "priyanshdatyalclicks.appspot.com",
    messagingSenderId: "458605200409",
    appId: "1:458605200409:web:ff78878d6c38a3b64c1688",
    measurementId: "G-WCR5TN7GLH"
  };


  const app = initializeApp(firebaseConfig);
  const db = getDatabase(app)
  const [backgroundImage, setBackgroundImage] = useState()
  const firebaseRef = ref(db, 'appui');

  const locationRoute=window.location.href

  useEffect(() => {
    
      get(firebaseRef).then((snapshot) => {
        if (snapshot.exists()) {
          setBackgroundImage(snapshot.val().main_background_url);
        } else {
          console.log("No data available");
        }
      }).catch((error) => {
        console.error(error);
      });
  }, [])



  const [isEditing,setIsEditing] = useState(false)

  const onEditClick=()=>{
    setIsEditing(!isEditing)
  }

  return (
  <div className={"full_page"}  style={{ backgroundImage: `url(${backgroundImage})` }}>
  
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CommonBase route={route} backgroundImageUrl={backgroundImage} theme={theme} />}></Route>
        <Route path="/natures" element={<Nature category={"nature"} theme={theme} onEditClick={onEditClick} isEditing={isEditing} />}></Route>
        <Route path="/street" element={<Street category={"street"} theme={theme} onEditClick={onEditClick} isEditing={isEditing} />}></Route>
        <Route path="/travel" element={<Travel category={"travel"} theme={theme} onEditClick={onEditClick} isEditing={isEditing} />}></Route>
        <Route path="/product" element={<Product category={"product"} theme={theme} onEditClick={onEditClick} isEditing={isEditing} />}></Route>
        <Route path="/wildlife" element={<Wildlife category={"wildlife"} theme={theme} onEditClick={onEditClick} isEditing={isEditing} />}></Route>
        <Route path="/videos" element={<Video category={"videos"} theme={theme} onEditClick={onEditClick} isEditing={isEditing} />}></Route>
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
